import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import { setDefaultOrganization } from '../../state/token'
import { useDispatch, useSelector } from 'react-redux'
import { OrganizationService } from '../../services'
export const OrganizationSelector = ({
  organization,
  organizationRight,
  variant,
}) => {
  const dispatch = useDispatch()
  const setOrganization = () => {
    if (organization) {
      dispatch(setDefaultOrganization(organization))
    }
    if (organizationRight) {
      new OrganizationService(organizationRight.organization)
        .makeGetRequest()
        .then((organization) => {
          dispatch(setDefaultOrganization(organization))
        })
    }
  }
  const { machineConfig } = useSelector((state) => state)
  const message = organization
    ? `Set default location to ${organization.code}?`
    : `Set default location to ${organizationRight.organization_name}?`
  const isCurrent = () => {
    if (organization) {
      return (
        machineConfig.organization &&
        machineConfig.organization.url === organization.url
      )
    }
    if (organizationRight) {
      return (
        machineConfig.organization &&
        machineConfig.organization.code === organizationRight.organization_code
      )
    }
  }
  return (
    <components.Confirm
      onConfirm={(e) => {
        setOrganization(organization)
      }}
      body={message}
      confirmText={
        organization
          ? `Select ${organization.name}-${organization.code}?`
          : `Select ${organizationRight.organization_name}`
      }
      confirmBSStyle="danger"
      title="Default Location"
    >
      {variant == 'Button' ? (
        <ReactBootstrap.Button
          disabled={isCurrent()}
          block
          variant="link"
          size="sm"
          className={'text-dark'}
        >
          {components.ICONS.HOME}{' '}
          <span className="ml-1">Select as default location</span>
        </ReactBootstrap.Button>
      ) : (
        <ReactBootstrap.NavDropdown.Item disabled={isCurrent()} block size="sm">
          {components.ICONS.HOME}{' '}
          <span className="ml-1">Select as default location</span>
        </ReactBootstrap.NavDropdown.Item>
      )}
    </components.Confirm>
  )
}
